import '@babel/polyfill';
import Vue from 'vue';
import vuetify from './plugins/vuetify';
import 'material-design-icons-iconfont/dist/material-design-icons.css';
import App from './App.vue';
import router from '@/router';
import store from '@/store';
import '@/firebase';
import firebase from 'firebase';

Vue.config.productionTip = false;
Vue.config.devtools = true;
let app;

const initialize = () => {
    if (!app) {
        app = new Vue({
            vuetify,
            router,
            store,
            render: h => h(App)
        }).$mount('#app');
    }
};

firebase.auth().onAuthStateChanged(user => {
    if (user) {
        store.commit('setFbUser', user);
        store.commit('setIsAuthenticated', true);
        store.dispatch('initialize');
    } else {
        store.commit('setFbUser', null);
        store.commit('setIsAuthenticated', false);
    }

    initialize();
});
